<div class="px-3">
  <div class="text-lg">
    Communications Platform Configuration
  </div>

  <div class="mt-6 grid">
    <div class="col-12 md:col-4">
      <creditor-autocomplete
      [styleClass]="'w-full'"
      (onSelect)="onSelectCreditor($event)"
      ></creditor-autocomplete> 
    </div>
  </div>


  <div class="grid mt-2">
    <div class="col-12 md:col-8">
      <p-tabView (onChange)="onChangeTab($event)" [(activeIndex)]="activeIndex">
        <p-tabPanel header="Twilio">
          <div *ngIf="selectedCreditorId">
            <div class="grid">
              <div class="col-12 md:col-6">              
                  <div class="mt-5">
                      <p-floatLabel>
                        <input [(ngModel)]="twilio.AccountSid" class="w-full"  pInputText id="TWAccountSid" placeholder="Account SId"  />
                        <label for="TWAccountSid">Account SId</label>
                      </p-floatLabel>
                  </div>
  
                  <div class="mt-5">
                    <p-floatLabel>
                      <input [(ngModel)]="twilio.MessagingServiceSid" class="w-full" pInputText id="TWMessagingServiceSid" placeholder="Messaging Service SId"  />
                      <label for="TWMessagingServiceSid">Messaging Service SId</label>
                    </p-floatLabel>
                  </div>
              </div>
  
              <div class="col-12 md:col-6">               
  
                <div class="mt-5">
                  <p-floatLabel>
                    <input [(ngModel)]="twilio.AuthToken" class="w-full" pInputText id="TWAuthToken" placeholder="Auth Token"  />
                    <label for="TWAuthToken">Auth Token</label>
                  </p-floatLabel>
                </div>

                <div class="mt-5 flex align-items-center">
                  <label for="TWIsEnabled">Is Twilio Config Enabled</label>
                  <p-inputSwitch [(ngModel)]="IsTwilioEnabled"  class="ml-2" inputId="TWIsEnabled" />
                </div>
                
              </div>
            </div> 
  
            <div class="flex justify-content-end mt-3 gap-2">
              <div *ngIf="twilio.TwilioIntegrationId">
                <remitter-button
                  pTooltip="Delete Twilio Integration"
                  label="Delete"
                  icon="trash"
                  severity="info"
                  (click)="openDeleteModal()"
                  />
              </div>

                <remitter-button
                  [label]="!twilio.TwilioIntegrationId? 'Create' : 'Update'"
                  icon='send' 
                  (click)="saveTwilio()"
                  >     
                </remitter-button>
            
            </div>
          </div>         
        </p-tabPanel>

        <p-tabPanel header="Telgorithm">
          <div *ngIf="selectedCreditorId">
            <div class="grid">
              <div class="col-12 md:col-6">              
                  <div class="mt-5">
                      <p-floatLabel>
                        <input [(ngModel)]="telgorithm.BaseUrl" class="w-full"  pInputText id="TGBaseUrl" placeholder="Base Url"  />
                        <label for="TGBaseUrl">Base Url</label>
                      </p-floatLabel>
                  </div>
  
                  <div class="mt-5">
                    <p-floatLabel>
                      <input [(ngModel)]="telgorithm.CompanySid" class="w-full" pInputText id="TGCompanySid" placeholder="Company SId"  />
                      <label for="TGCompanySid">Company SId</label>
                    </p-floatLabel>
                  </div>
  
                 
  
              </div>
  
              <div class="col-12 md:col-6">
               
  
                <div class="mt-5">
                  <p-floatLabel>
                    <p-inputNumber 
                      class="w-full"
                      styleClass="w-full"
                      inputStyleClass="w-full"
                      inputId="integeronly" 
                      [(ngModel)]="telgorithm.ExpirationInMinutes"
                      id="TGExpirationInMinutes" placeholder="Expiration In Minutes"
                      /> 
                    <label for="TGExpirationInMinutes">Expiration In Minutes</label>
                  </p-floatLabel>
                </div>

                 <div class="mt-5">
                    <p-floatLabel>
                      <input [(ngModel)]="telgorithm.PrimaryToken" class="w-full" pInputText id="TGPrimaryToken" placeholder="Primary Token"  />
                      <label for="TGPrimaryToken">Primary Token</label>
                    </p-floatLabel>
                  </div>
  
                  <div class="mt-5 flex align-items-center">
                    <label for="TGIsEnabled">Is Telgorithm Config Enabled</label>
                    <p-inputSwitch [(ngModel)]="isTelgorithmEnabled" class="ml-2" inputId="TGIsEnabled" />
                  </div>
              
               
              </div>
            </div> 
  
            <div class="flex justify-content-end mt-3 gap-2">
               <div 
                *ngIf="telgorithm.TelgorithmIntegrationId">
                  <remitter-button
                    pTooltip="Delete Telgorithm Integration"
                    label="Delete"
                    icon="trash"
                    severity="info"
                    (click)="openDeleteModal()"
                    />
              </div>

                <remitter-button
                  [label]="!telgorithm.TelgorithmIntegrationId? 'Create' : 'Update'"
                  icon='send' 
                  (click)="saveTelgorithm()"
                  >     
                </remitter-button>    
              </div>

              <div *ngIf="telgorithm.TelgorithmIntegrationId" class="mt-5">
                  <div class="flex justify-content-between mb-5">
                      <div>Mobile Numbers</div>
                      <div>
                        <icon-button
                            pTooltip='Add New Mobile'
                            tooltipPosition='left'
                            (click)="onAddNewMobile()"
                            [icon]="'plus'"
                          />
                      </div>
                  </div>

                   <p-table
                      [value]="telgorithmMobileNumbers" 
                      [tableStyle]="{ 'min-width': '50rem' }"
                      [paginator]="false">
                    <ng-template pTemplate="header">
                        <tr class="text-xs">
                            <th>Mobile Number</th>
                            <th>Is Enabled</th>    
                            <th>Action</th>              
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-mobile>
                        <tr class="text-xs">
                            <td>{{ mobile.MobileNumber }}</td>
                            <td>{{ !mobile.IsDisabled? 'Yes' : 'No' }}</td>      
                            <td>
                                <div class="flex align-items-center">
                                    <icon-button
                                      pTooltip='Edit'
                                      tooltipPosition='left'
                                      (click)="onEditMobile(mobile, mobile.TelgorithmIntegrationMobileNumberId)"
                                      [icon]="'pencil'"
                                      [styleClass]="'mr-1'"
                                    />

                                    <icon-button
                                      pTooltip='Delete'
                                      tooltipPosition='left'
                                      (click)="onDeleteMobile(mobile.TelgorithmIntegrationMobileNumberId)"
                                      [icon]="'trash'"
                                    />                                    
                                  </div>
                            </td>       
                        </tr>
                    </ng-template>
                </p-table>


              </div>
          </div>         
        </p-tabPanel>

        <p-tabPanel header="SendGrid">
           <div *ngIf="selectedCreditorId">
              <div class="grid">
                <div class="col-12 md:col-6">

                    <div class="mt-5">
                      <p-floatLabel>
                        <input [(ngModel)]="sendGrid.ApiKey" class="w-full" pInputText id="SGApiKey" placeholder="API Key"  />              
                        <label for="SGApiKey">API Key</label>
                      </p-floatLabel>
                    </div>

                    <div class="mt-5">
                      <p-floatLabel>
                        <input [(ngModel)]="sendGrid.SenderAddress" class="w-full" pInputText id="SGSenderAddress" placeholder="Sender Address"  />
                        <label for="SGSenderAddress">Sender Address</label>
                      </p-floatLabel>
                    </div>

                    <div class="mt-5">
                      <p-floatLabel>
                        <input [(ngModel)]="sendGrid.SenderFullName" class="w-full"  pInputText id="SGSenderFullName" placeholder="Sender Fullname"  />
                        <label for="SGSenderFullName">Sender Fullname</label>
                      </p-floatLabel>
                    </div>

                </div>

                <div class="col-12 md:col-6">

                    <div class="mt-5">
                        <p-floatLabel>
                          <input [(ngModel)]="sendGrid.BccAddress" class="w-full" pInputText id="SGBccAddress" placeholder="Bcc Address"  />
                          <label for="SGBccAddress">Bcc Address</label>
                        </p-floatLabel>
                    </div>

                    <div class="mt-5">
                      <p-floatLabel>
                        <input [(ngModel)]="sendGrid.ReplyToAddress" class="w-full" pInputText id="SGReplyToAddress" placeholder="Reply To Address"  />
                        <label for="SGReplyToAddress">Reply To Address</label>
                      </p-floatLabel>
                    </div>     
                    
                     <div class="mt-5 flex flex-wrap align-items-center justify-content-between">
                       <div class="flex align-items-center">
                         <label for="SGEnableSsl">Enable SSL</label>
                         <p-inputSwitch [(ngModel)]="sendGrid.EnableSsl" class="ml-2" inputId="SGEnableSsl" />
                       </div>
                       <div class="flex align-items-center">
                        <label for="SGIsEnabled">Is SendGrid Enabled</label>
                        <p-inputSwitch [(ngModel)]="IsSendGridEnabled" class="ml-2" inputId="SGIsEnabled" />
                      </div>
                    </div>

                    

                </div>
              </div> 

              <div class="flex justify-content-end mt-3 gap-2">
                <div  *ngIf="sendGrid.SendGridIntegrationId">
                  <remitter-button
                    pTooltip="Delete SendGrid Integration"
                    label="Delete"
                    icon="trash"
                    severity="info"
                    (click)="openDeleteModal()"
                  />
                </div>


                <remitter-button
                  [label]="!sendGrid.SendGridIntegrationId? 'Create' : 'Update'"
                  icon='send' 
                  (click)="saveSendGrid()"
                  >     
                </remitter-button>     
              </div>
           </div>
          
        </p-tabPanel>
<!-- 
        <p-tabPanel header="Bandwidth">
            <div *ngIf="selectedCreditorId">
              <div class="grid">
                <div class="col-12 md:col-6">
                  
                    <div class="mt-5">
                        <p-floatLabel>
                          <input class="w-full"  pInputText id="BWBaseUrl" [(ngModel)]="bandwidthConfig.BaseUrl" placeholder="Base Url"  />
                          <label for="BWBaseUrl">Base Url</label>
                        </p-floatLabel>
                    </div>
  
                    <div class="mt-5">
                      <p-floatLabel>
                        <input class="w-full" pInputText id="BWUsername" [(ngModel)]="bandwidthConfig.Username" placeholder="Username"  />
                        <label for="BWUsername">Username</label>
                      </p-floatLabel>
                    </div>
  
                    <div class="mt-5">
                      <p-floatLabel>
                        <input class="w-full" pInputText id="BWPassword" [(ngModel)]="bandwidthConfig.Password" placeholder="Password"  />
                        <label for="BWPassword">Password</label>
                      </p-floatLabel>
                    </div>                  
  
                    <div class="mt-5 flex align-items-center">
                      <label for="BWIsDisabled">Is Bandwidth Config Disabled</label>
                      <p-inputSwitch class="ml-2" [(ngModel)]="bandwidthConfig.IsDisabled" inputId="BWIsDisabled" />
                    </div>
  
                </div>
  
                <div class="col-12 md:col-6">
                   <div class="mt-5">
                      <p-floatLabel>
                        <input class="w-full" pInputText id="BWApplicationId" [(ngModel)]="bandwidthConfig.ApplicationId" placeholder="Application Id"  />
                        <label for="BWApplicationId">Application Id</label>
                      </p-floatLabel>
                    </div>
  
                  <div class="mt-5">
                    <p-floatLabel>
                      <input class="w-full" pInputText id="BWAccountId" [(ngModel)]="bandwidthConfig.AccountId"  placeholder="Account Id"  />
                      <label for="BWAccountId">Account Id</label>
                    </p-floatLabel>
                  </div>
  
                  <div class="mt-5">
                    <p-floatLabel>
                      <input class="w-full" pInputText id="BWExpirationInMinutes" [(ngModel)]="bandwidthConfig.ExpirationInMinutes" placeholder="Expiration In Minutes"  />
                      <label for="BWExpirationInMinutes">Expiration In Minutes</label>
                    </p-floatLabel>
                  </div>
                  
                </div>
              </div> 

              <div class="flex justify-content-end gap-2 mt-3">
                <remitter-button
                  pTooltip="Delete Bandwidth Config"
                  tooltipPosition="top"
                  label="Delete"
                  [icon]="'trash'"
                  severity="outline"
                  (click)="onDeleteBandwidthConfig()"
                />
                <remitter-button
                  label='Save'
                  [icon]="'send'" 
                  (click)="onSaveBandwidthConfig()"
                  >     
                </remitter-button>
              </div>
  
              <div *ngIf="bandwidthConfig.BandwidthIntegrationId" class="mt-5">
                  <div class="flex justify-content-between mb-5">
                      <div>Mobile Numbers</div>
                      <div>
                        <icon-button
                            pTooltip='Add New Mobile'
                            tooltipPosition='left'
                            (click)="onAddNewMobile()"
                            [icon]="'plus'"
                          />
                      </div>
                  </div>

                   <p-table
                      [value]="bandwidthConfigMobileNumbers" 
                      [tableStyle]="{ 'min-width': '50rem' }"
                      [paginator]="false">
                    <ng-template pTemplate="header">
                        <tr class="text-xs">
                            <th>Mobile Number</th>
                            <th>Is Disabled</th>    
                            <th>Action</th>              
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-mobile>
                        <tr class="text-xs">
                            <td>{{ mobile.MobileNumber }}</td>
                            <td>{{ mobile.IsDisabled? 'Yes' : 'No' }}</td>      
                            <td>
                                <div class="flex align-items-center">
                                    <icon-button
                                      pTooltip='Edit'
                                      tooltipPosition='left'
                                      (click)="onEditMobile(mobile)"
                                      [icon]="'pencil'"
                                      [styleClass]="'mr-1'"
                                    />

                                    <icon-button
                                      pTooltip='Delete'
                                      tooltipPosition='left'
                                      (click)="onDeleteMobile(mobile)"
                                      [icon]="'trash'"
                                    />                                    
                                  </div>
                            </td>       
                        </tr>
                    </ng-template>
                </p-table>


              </div>

            </div>
        </p-tabPanel> -->

      </p-tabView>
    </div>

    <div *ngIf="!selectedCreditorId" class="col-12 md:col-8 text-center" style="color:red">
      Please select a Creditor.
    </div>
    
  </div>
</div>


<common-delete-modal 
  [(visible)]="isDeleteModalVisible" 
  [message]="'Are you sure you want to delete this config?'" 
  width="30vw"
  (actionClicked)="onConfirmDelete()">
</common-delete-modal>

<common-delete-modal 
  [(visible)]="isDeleteMobileModalVisible" 
  [message]="'Are you sure you want to delete this mobile number?'" 
  width="30vw"
  (actionClicked)="onConfirmDeleteMobile()">
</common-delete-modal>

<p-sidebar [(visible)]="isSidebarVisible" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      
      <div class="text-xl font-medium">{{sidebarOperation}} Mobile Number</div>
    
      <div class="flex align-items-center gap-4 mt-4">
        <div>
          <p-floatLabel>
             <input class="w-full" pInputText id="MobileNumber" [(ngModel)]="sidebarMobileNumber" placeholder="Mobile Number"  />
              <label for="MobileNumber">Mobile Number</label>
          </p-floatLabel>
        </div>
  
        <div class="flex align-items-center">
               <label for="IsMobileNumberEnabled">Is Mobile Number Enabled</label>
               <p-inputSwitch class="ml-2" inputId="IsMobileNumberEnabled" [(ngModel)]="sidebarIsEnabled" />
        </div>
      </div>
    
      <div class="flex justify-content-end mt-4">
        
            <remitter-button
              label='Save'
              icon='send'
              (click)="onSaveMobileNumber()" 
              >     
            </remitter-button>
        
      </div>
    </div>
  </p-sidebar>
